// Envision - dropdown navigation functionality on mobile support and blog pages
$(function() {
  if ($('select.support-nav-select').length) {
    $('select.support-nav-select').on('change', function() {
      var url = $(this).val();
      window.location.href = url;
    });
  }
  
  if ($('select.blog-nav-select').length) {
    console.log('found blog nav select');
    $('select.blog-nav-select').on('change', function() {
      var url = $(this).val();
      window.location.href = url;
    });
  }
});

// Envision - free shipping countdown
$(function() {
  var shipping_countdown_container = $('.free-shipping-countdown[data-shipping-value]');
  if (shipping_countdown_container.length) {
    
    // listen for cart AJAX event, update totals when complete
    $(document).ajaxComplete(function( event, xhr, settings ) {
      if (settings && (settings.url === "/cart/add.js" || settings.url === "/cart/change.js" || settings.url === "/cart/update.js" || settings.url === "/cart/clear.js")) {
        // get cart info
        $.getJSON( "/cart.js", function( cart ) {
          var shipping_value = shipping_countdown_container.data('shipping-value');
          var cart_total = cart.total_price;
          var amount_remaining = shipping_value - cart_total;
          
          if (amount_remaining > 0) {
            $('[data-amount-remaining]', shipping_countdown_container).text(Shopify.formatMoney(amount_remaining, Shopify.money_format));
            
            $('.countdown-notqualified', shipping_countdown_container).removeClass('hidden');
            $('.countdown-qualified', shipping_countdown_container).addClass('hidden');
          } else {
            $('.countdown-notqualified', shipping_countdown_container).addClass('hidden');
            $('.countdown-qualified', shipping_countdown_container).removeClass('hidden');
          }
        });
      }
    }); 
  }
});